import { useLayoutEffect } from 'react'

/* The react-hooks/exhaustive-deps lint rule exists to ensure that all props
 * used in `useEffect` and `useLayoutEffect` are declared as proprties of that
 * hook. That's often the right thing to do, but sometimes we want a hook that
 * will run exactly once after the component is first rendered and inserted
 * into the DOM. For that, we want to explicitly declare an empty dependencies
 * list. This hook does that.
 *
 * Use it to fetch data on first load:
 *
 * function FetchAndShowInfo({ fetchInfo, info }) {
 *   useAfterFirstRender(fetchInfo)
 *   return info == null ? <Loading /> : <span>{info}</span>
 * }
 *
 * Use it to manage global event listeners:
 *
 * function Help() {
 *   const [isOpen, setIsOpen] = useState(false)
 *   const showHelp = useRef(() => setIsOpen(true))
 *
 *   useAfterFirstRender(() => {
 *     KeyboardShortcuts.add('?', showHelp)
 *
 *     return () => {
 *       KeyboardShortcuts.remove('?', showHelp)
 *     }
 *   })
 * }
 */
export default function useAfterFirstRender(fn) {
  return useLayoutEffect(fn, [])
}
